<div class="payment-result" [class]="'payment-result--' + tone()">
  @switch (status()) {
    @case ('VALIDATED') {
      <app-payment-result-validated [message]="message()" />
    }
    @case ('DATE_EXPIRED') {
      <app-payment-result-date-expired [message]="message()" />
    }
    @case ('DUPLICATED') {
      <app-payment-result-duplicated [message]="message()" />
    }
    @case ('NON_PAYMENT_IMAGE') {
      <app-payment-result-non-payment-image />
    }
    @case ('NOT_FOUND') {
      <app-payment-result-not-found
        [message]="message()"
        (manualValidationRequested)="manualValidationRequested.emit($event)"
      />
    }
    @case ('MANUAL_REVIEW_REQUIRED') {
      <app-payment-result-manual-review
        [message]="message()"
        (formRequested)="manualValidationRequested.emit($event)"
      />
    }
    @default {
      <app-payment-result-generic [status]="status()" />
    }
  }
</div>
